import React from 'react';

import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';
import { AttachmentsPageLoader } from '@confluence/attachments-page/entry-points/AttachmentsPage';
import type { RouteMatch } from '@confluence/route';
import { expValEquals } from '@confluence/feature-experiments';
import { NotFound } from '@confluence/not-found';

export const AttachmentsPageRoute = ({ params: { contentId, spaceKey } }: RouteMatch) => {
	if (!expValEquals('cc_attachments_page', 'isEnabled', true)) {
		return <NotFound />;
	}
	return <AttachmentsPageLoader contentId={contentId} spaceKey={spaceKey} />;
};

AttachmentsPageRoute.NAVIGATION_PARAMS = ({ name: routeName, params }: RouteMatch) => {
	const { spaceKey, contentId } = params;

	return {
		Screen: {
			screenEvent: { name: 'attachmentsPage', id: contentId },
			pageState: {
				routeName,
				contentId,
				spaceKey,
			},
		},
		MainLayout: {
			navView: CONTAINER_HOME_ID,
			spaceKey,
		},
	};
};
